// extracted by mini-css-extract-plugin
module.exports = {"row":"layout_row__KRxs6","item":"layout_item__92yJx"};